import React, { useEffect, useState, useRef } from "react";
import { io } from "socket.io-client";

const ChatBox = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const socket = useRef();

  const handleSendMessage = () => {
    if (input.trim() === "") return; // Don't send empty messages

    // Send the chat message via WebSocket
    socket.current.emit("send.sdp", {
      action: "chat-message",
      message: input,
      sender: "User A",
    });

    setInput("");
  };

  useEffect(() => {
    // Connect to WebSocket server
    socket.current = io("ws://localhost:8001/ws/telemedicine/");

    // Function to handle incoming messages
    socket.current.on("receive.sdp", (data) => {
      // Handle the received message data
        if (data.action === "chat-message") {
           const messageData = {
          message: data.message,
          sender: data.sender,
        };
        setMessages((prevMessages) => [...prevMessages, data.message]);
      }
    });

    // Function to handle leaving the chat room
    return () => {
      // Close the WebSocket connection when the component is unmounted
      socket.current.disconnect();
    };
  }, []);

  return (
    <div>
      <h2>Chat Box</h2>
      <div>
        {messages.map((message, index) => (
          <div key={index}>{message}</div>
        ))}
      </div>
      <input type="text" value={input} onChange={(e) => setInput(e.target.value)} />
      <button onClick={handleSendMessage}>Send</button>
    </div>
  );
};

const RoomPage = () => {
  return (
    <div>

      <ChatBox />
    </div>
  );
};

export default RoomPage;